import edm from '@bingads-webui-component-legacy/edm-campaign/index';

export const NavigationLevel = {
  Customer: 'customer',
  Account: 'account',
  Campaign: 'campaign',
};

export function getNavigationLevel(scopeValues) {
  const {
    aid,
    campaignId,
  } = scopeValues;
  let result = NavigationLevel.Customer;
  if (campaignId) {
    result = NavigationLevel.Campaign;
  } else if (aid || edm.currentAccount) {
    result = NavigationLevel.Account;
  }

  return result;
}
